<template>
  <div style=" margin: 10px;">
    <div v-if="!$store.state.course.isGoodsLoaded">
      <div>
        <van-loading class="loading" size="40px" vertical
          >加载中...</van-loading
        >
      </div>
    </div>

    <div
      v-if="
        $store.state.course.isGoodsLoaded &&
          $store.state.course.packages.length > 0
      "
    >
      <div style="padding-bottom: 10px;color: #444444">
        <b>请选择您要报名的课程：</b>
      </div>
      <van-row
        style="padding: 10px;font-size: 14px;line-height: 24px;"
        v-for="(item, index) in $store.state.course.packages"
        :key="index"
      >
        <van-col span="1"></van-col>
        <van-col span="21" style="padding-right: 5px"
          ><div>
            <span>{{ item.name }}</span
            ><span style="color: red"> ￥{{ item.price }}</span>
          </div></van-col
        >
        <van-col span="2"
          ><van-checkbox
            v-model="$store.state.course.packages[index].checked"
            @click="afterSelectPkg(item.id)"
        /></van-col>
      </van-row>
      <!--      <div v-html="package_msg"></div> TODO: 显示课程包装的提示信息-->
      <br />
      <div v-if="$store.state.course.courseTermModel.length > 0">
        <div style="padding-bottom: 10px;color: #444444">
          <b>请选择要参加的期次：</b>
        </div>
        <div
          style="color:#1989fa;"
          v-for="(item, index) in $store.state.course.courseTermModel"
          :key="index"
        >
          <div style="padding-bottom: 5px">
            <van-icon
              name="underway"
              size="0.5rem"
              style="padding-right: 2px"
            />{{ item.course.name }}
          </div>
          <van-radio-group
            :model-value="
              $store.state.course.courseTermModel[index].checkedTerm
            "
          >
            <van-cell-group>
              <van-cell
                v-for="(term, term_index) in item.course.terms"
                :key="term_index"
                @click="afterSelectTerm(index, term.id)"
              >
                <template #title>
                  <div>
                    <span v-html="setTermDisplay(term)"></span>
                    <span style="color: red" v-if="term.coupon_seats_left > 0"
                      >(前20名优惠中)</span
                    >
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="term.id" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <div
            v-html="$store.state.course.courseTermModel[index].term_msg"
          ></div>
        </div>
      </div>
      <br />
      <div>
        <div v-if="$store.state.course.couponModel.length > 0">
          <div style="padding-bottom: 10px;color: #444444">
            <b>请勾选您是否满足下列优惠条件：</b>
            <p style="color: #969799; font-size: small">
              后续需要您提交对应凭证，审核通过后可以享受优惠。
            </p>
          </div>
          <van-row
            style="padding: 10px;font-size: 14px;line-height: 24px;"
            v-for="(item, index) in $store.state.course.couponModel"
            :key="index"
          >
            <van-col span="1"
              ><van-icon name="question" color="#ee0a24" size="0.5rem"
            /></van-col>
            <van-col span="21" style="padding-right: 5px"
              ><div v-html="item.text"></div
            ></van-col>
            <van-col span="2"
              ><van-checkbox
                v-model="$store.state.course.couponModel[index].checked"
                @click="onClickCoupon($store.state.course.couponModel[index])"
            /></van-col>
          </van-row>
        </div>
        <van-field name="needInvoice" label="是否需要发票">
          <template #input>
            <van-switch v-model="$store.state.course.isNeedInvoice" size="20" />
          </template>
        </van-field>
        <van-field
          v-model="$store.state.course.registerNote"
          name="留言"
          label="给管理员留言"
          placeholder="选填，有任何问题请留言"
          :rules="[{ required: false }]"
        />
      </div>
    </div>

    <div
      v-if="
        $store.state.student.isStudentLoaded && !$store.state.student.hasStudent
      "
    >
      <div style="padding-top:30px; padding-bottom: 10px;color: #444444">
        <b>请填写您的个人信息：</b>
      </div>
      <van-form
        ref="student_form"
        @submit="submit"
        @failed="student_form_faild"
      >
        <van-field
          v-model="$store.state.student.name"
          name="姓名"
          label="姓名"
          placeholder="用于课程证书，请写真实姓名"
          :rules="[{ required: true, message: '未填写姓名' }]"
        />
        <van-field
          v-model="$store.state.student.en_name"
          name="英文名"
          label="英文名或拼音"
          placeholder="将用于课程证书"
          :rules="[{ required: true, message: '未填写英文名或拼音' }]"
        />
        <van-field
          name="radio"
          label="性别"
          :rules="[{ required: true, message: '请选择性别' }]"
        >
          <template #input>
            <van-radio-group
              v-model="$store.state.student.gender"
              direction="horizontal"
            >
              <van-radio name="M">男</van-radio>
              <van-radio name="F">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="$store.state.student.phone"
          name="电话"
          label="电话号码"
          placeholder="电话号码"
          :rules="[{ required: true, message: '没有填写联系电话' }]"
        />
        <van-field
          v-model="$store.state.student.bk_phone"
          name="备用电话"
          label="备用电话"
          placeholder="选填"
        />
        <van-field
          v-model="$store.state.student.im"
          name="IM"
          label="IM"
          placeholder="可联系您的微信,QQ或Facebook等"
          :rules="[{ required: true, message: '请填写社交账号' }]"
        />
        <van-field
          v-model="$store.state.student.email"
          name="电子邮件"
          label="电子邮件"
          placeholder="有效的电子邮箱"
          :rules="[
            {
              validator: emailValidator,
              required: true,
              message: '请填写有效的电子邮件地址'
            }
          ]"
        />
        <van-field
          v-model="$store.state.student.speciality"
          name="行业"
          label="行业/专业"
          :rules="[{ required: true, message: '未填写行业/专业' }]"
        />
        <van-field
          v-model="$store.state.student.company"
          name="公司"
          label="公司/学校"
          :rules="[{ required: true, message: '未填写公司/学校' }]"
        />
      </van-form>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <!--    提交栏-->
    <div>
      <van-submit-bar
        v-if="$store.getters['course/currentRegPkg'] !== null"
        :price="userPrice[1]"
        native-type="submit"
        @submit="submit"
        button-text="提交报名"
        label="根据勾选项预算学费："
      >
        <template #tip>
          <div v-if="$store.getters['course/selectedTerms'].length === 0">
            还没有选择期次，选择后显示优惠
          </div>
          <div
            v-if="
              $store.getters['course/selectedTerms'].length > 0 &&
                userPrice[1] !== userPrice[0]
            "
          >
            <div>{{ userPrice[2] }}</div>
            <div
              v-if="
                $store.getters['course/timeToEarlyBirdEnd'] > 0 &&
                  $store.getters['course/selectedTerms'].length > 0
              "
            >
              <van-count-down
                class="coupon_tips"
                :time="$store.getters['course/timeToEarlyBirdEnd']"
                format="DD天HH:mm:ss"
              />
              <span
                v-if="
                  $store.getters['course/timeToEarlyBirdEnd'] > 0 &&
                    $store.getters['course/selectedTerms'].length > 0
                "
                >后优惠结束，
              </span>
              恢复课程原价：￥{{ userPrice[0] / 100 }}
            </div>
          </div>
        </template>
      </van-submit-bar>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Loading,
  SubmitBar,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  Form,
  Field,
  Switch,
  Checkbox,
  Button,
  CountDown,
  Dialog,
  Icon
} from "vant";
// import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { warningNotify } from "@/utils/notify";

export default {
  name: "course_register",
  props: ["id"],
  data() {
    return {
      selectedTermIds: {},
      packages_msg: [],
      term_msg: ""
    };
  },
  computed: {
    ...mapGetters({
      userPrice: "course/userPrice"
    })
  },
  components: {
    [Loading.name]: Loading,
    [SubmitBar.name]: SubmitBar,
    [Cell.name]: Cell,
    "van-cell-group": CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Checkbox.name]: Checkbox,
    "van-row": Row,
    "van-col": Col,
    [Button.name]: Button,
    "van-count-down": CountDown,
    [Icon.name]: Icon
  },
  methods: {
    setTermDisplay(term) {
      console.log(term);
      if (term.is_booking) {
        return `${term.location.name} ${term.booking_msg}`;
      }
      return `${term.location.name} ${term.start_date} ~ ${term.end_date}`;
    },
    onClickCoupon(coupon) {
      if (
        coupon.checked &&
        coupon.dialog !== undefined &&
        coupon.dialog !== null &&
        coupon.dialog !== ""
      ) {
        Dialog.alert({ message: coupon.dialog });
      }
    },
    onClickTerm(course_id, term_id) {
      // VUE 不支持 state.object.sub_object[key] 中 key 对应的值发生变化以后对页面做出刷新，但可以用下面的 $set 解决。
      // 后来已经没有用这个了，先放这里当个范例。
      this.$set(this.selectedTermIds, course_id, term_id);
      this.$store.commit("course/setRegisterCourseTerm", {
        course_id,
        term_id
      });
    },
    // 选取完课程包装以后的操作，这里会根据选取的课程包装动态生成期次的选择和优惠项目的选择
    afterSelectPkg(id) {
      // 添加了下面的判断，使原本的多选变成了单选，课程包装列表中只能有一个被选中，所以这里要把其他的都取消掉
      this.$store.state.course.packages.forEach(item => {
        if (item.id !== id) item["checked"] = false;
      });

      let pkgs = this.$store.getters["course/selectedPkgs"];
      let courses = this.$store.getters["course/coursesInSelectedPkgs"];
      let coursesModel = [];
      courses.forEach(course => {
        let item = {
          id: course.id,
          course: course,
          checkedTerm: -1,
          term_msg: ""
        };
        coursesModel.push(item);
        coursesModel.sort(
          (a, b) => a.course.display_priority - b.course.display_priority
        );
      });
      this.$store.commit("course/setCourseTermModel", coursesModel);
      let coupons = this.$store.getters["course/allCouponsInSelectedPkgs"];
      this.$store.commit("course/setCouponModel", coupons);
      let pkg = pkgs.filter(item => item.id === id)[0];
      // 显示课程包装本身设置的弹窗
      if (pkg.checked && pkg.dialog_msg !== null && pkg.dialog_msg !== "") {
        Dialog.alert({ message: pkg.dialog_msg });
      }
      // 判断用户是不是已经报名过了这个课程包装，报名过了弹出提示
      if (this.$store.state.userCourses.isCourseInfosLoaded) {
        this.$store.state.userCourses.courseInfos.forEach(item => {
          if (item.course_package.id === pkg.id) {
            Dialog.confirm({
              message:
                '您已经报名过这个课程，点击"已报课程"前往查看已经报名的课程。',
              confirmButtonText: "已报课程",
              cancelButtonText: "继续报名"
            })
              .then(() => {
                this.$router.push({ name: "myCourse" });
              })
              .catch(() => {});
          }
        });
      }
      // 只把选中的课程包装的 information 添加到信息列表，以便后面显示出这些信息
      this.packages_msg = [];
      pkgs.forEach(p => {
        if (p.checked) {
          this.packages_msg.push(p.information);
        }
      });
    },
    afterSelectTerm(index, term_id) {
      this.$store.commit("course/setClickedTerm", { index, term_id });
    },
    // 效验电子邮件的格式是否正确
    emailValidator(email) {
      return /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/.test(
        email
      );
    },
    submit() {
      // 如果没有学员，说明需要验证学员表单
      if (
        this.$store.state.student.isStudentLoaded &&
        !this.$store.state.student.hasStudent
      ) {
        // 对学员表单进行验证
        this.$refs.student_form
          .validate()
          .then(() => {
            this.$store.dispatch("course/submitCourseRegister");
          })
          .catch(() => {
            this.student_form_faild();
          });
      } else {
        this.$store.dispatch("course/submitCourseRegister");
      }
    },
    student_form_faild() {
      warningNotify("必填项没有填写，请检查");
    }
  },
  beforeMount() {
    // 应该在每个登录才能操作的视图加上下面这句
    this.$store.dispatch("users_tokenChecker");
    this.$store.dispatch("course/getCourseGoods");
    this.$store.commit("course/initCurrentRegisterCourse");
    let goodsId = this.$route.params.id;
    if (
      this.$store.state.course.isGoodsLoaded &&
      this.$store.state.course.currentRegisterGoodsId === -1
    ) {
      this.$store.commit("course/setCurrentRegisterGoods", goodsId);
    }
    // 首先清空再获取学员的所有学员课程信息
    this.$store.commit("userCourses/initCourseInfos");
    this.$store.dispatch("userCourses/getUserCourseInfos");
  },
  updated() {
    let goodsId = this.$route.params.id;
    if (
      this.$store.state.course.isGoodsLoaded &&
      this.$store.state.course.currentRegisterGoodsId === -1
    ) {
      this.$store.commit("course/setCurrentRegisterGoods", goodsId);
    }
    if (
      !this.$store.state.student.isStudentLoaded &&
      this.$store.getters.users_isStateTokenValid
    ) {
      this.$store.dispatch("student_getStudentFromServer");
    }
    if (!this.$store.state.userCourses.isCourseInfosLoaded) {
      // beforeMount 中虽然有，但这里是为了应对刷新页面以后 token 还没有的情况下做的
      this.$store.dispatch("userCourses/getUserCourseInfos");
    }
  }
};
</script>

<style scoped>
.loading {
  width: 80px;
  height: 50px;
  position: fixed;
  top: 20%;
  left: 0;
  right: 0;
  margin: 0 auto;
  color: #1989fa;
}
.van-radio-group {
  margin-bottom: 15px;
}
.van-row {
  background: white;
  margin-bottom: 2px;
}
.coupon_tips {
  display: inline;
  color: #f56723;
  font-size: 12px;
}
</style>
